import * as $ from 'jquery';
import * as angular from "angular";
import * as moment from "moment";

/** Set Moment defaults */
moment.locale('nl'); 

import '../scripts/assign.polyfill.js';

import 'angular-ui-router/release/angular-ui-router.js';

import 'lodash';
import 'restangular';
import 'angular-local-storage';
import 'ngletteravatar';
import 'angular-ui-router-uib-modal';
import 'bootstrap-datepicker';
import 'bootstrap-timepicker';
import 'angular-file-upload';
import 'angular-messages';
import 'moment';
import 'ng-device-detector';
import 'angular-media-queries';
import 'angular-file-saver';
import 'ng-infinite-scroll/build/ng-infinite-scroll.min.js';

import 'ngclipboard/dist/ngclipboard.min.js'

import '@abosol/theme';
import '@abosol/masterdata';

import 'angular-gettext';
import '../translations/nl_NL.po';

import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min.js';
import 'bootstrap-timepicker/css/bootstrap-timepicker.min.css';
// import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.js';
// import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.templates.js';
// import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';
// import 'angular-date-time-input/src/dateTimeInput.js';
import 'angular-permission';
import 'angular-filter/dist/angular-filter.min.js';



import '../less/app.less';

import './global';
import './main';
import './authorization';
import './authsettings';
import './modules';


angular.element(document).ready(function () {
    angular.bootstrap(document.body, ['app'], {
        strictDi: true
    });
}); 





// WEBPACK FOOTER //
// ./src/app/bootstrap.ts